import { FeatureCollection, IFeature } from './../models/feature.model';
import { Inject, Injectable } from '@angular/core';
import { ENV, IEnvironment } from 'env/config';

import { DataService } from '../http/dataService';
import { CentralApis } from '../interfaces/internal';
import { Repository } from './repository';

import { Service } from '../entity';
import { map, Observable } from 'rxjs';
import { Result } from '../index';
import { Address, ITerritoryAddress } from '../models';

@Service({
  api: 'territoryAddress',
  model: FeatureCollection,
})
@Injectable({ providedIn: 'root' })
export class TerritoryAddressService extends Repository<ITerritoryAddress> {
  constructor(@Inject(ENV) env: IEnvironment, dataService: DataService) {
    super({
      client: dataService,
      url: (env.api.backend.central.endpoint as CentralApis).territory,
    });
  }

  getAll<I>(queryParams?: any): Observable<Result<ITerritoryAddress>> {
    return super.getAll(queryParams);
  }
}
